export { ExtrasCard } from './ExtrasCard';
export type { ExtrasCardProps, ExtrasCardVariant } from './ExtrasCard.types';
